/* ShineWater Kids Winter Wonderland 2026. Every canvas effect skips the drink-box
   rectangle given in data-box (x0,y0,x1,y1 in % of the image), so the pack art is never drawn over. */
(function () {
  var root = document.getElementById('wn26');
  if (!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 749px)');
  var DPR = Math.min(window.devicePixelRatio || 1, 2);

  /* header floats over the hero: expose its height for the phone layout */
  var hdr = document.querySelector('.section-site-header .site-header');
  function setHdr() { if (hdr) root.style.setProperty('--wn-hdr', Math.round(hdr.getBoundingClientRect().height) + 'px'); }
  setHdr(); window.addEventListener('resize', setHdr); window.addEventListener('load', setHdr);

  /* hero carousel: four flavor slides, each plays its 8s clip once, then fades to the next */
  var car = root.querySelector('.wn-carousel');
  if (car) {
    var slides = [].slice.call(car.querySelectorAll('.wn-slide')), dots = [].slice.call(car.querySelectorAll('.wn-cdots button'));
    var cur = 0, paused = false, timer = null, inView = true;
    function vidOf(i) { return slides[i].querySelector('video'); }
    function playCur() {
      clearTimeout(timer);
      var v = vidOf(cur);
      if (!reduce && v) {
        if (!v.src) { v.src = v.dataset.src; }
        try { v.currentTime = 0; } catch (e) {}
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      if (!paused && inView) timer = setTimeout(function () { go(cur + 1); }, reduce ? 6000 : 8000);
      var nv = vidOf((cur + 1) % slides.length); if (!reduce && nv && !nv.src) { nv.preload = 'auto'; nv.src = nv.dataset.src; }
    }
    function go(i) {
      var prev = cur; cur = (i + slides.length) % slides.length; if (prev === cur) return playCur();
      slides[prev].classList.remove('is-active'); slides[cur].classList.add('is-active');
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === cur ? 'true' : 'false'); });
      var pv = vidOf(prev); setTimeout(function () { if (pv) pv.pause(); }, 900);
      playCur();
    }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.i); }); });
    car.querySelector('.wn-cprev').addEventListener('click', function () { go(cur - 1); });
    car.querySelector('.wn-cnext').addEventListener('click', function () { go(cur + 1); });
    var pb = car.querySelector('.wn-cpause');
    pb.addEventListener('click', function () {
      paused = !paused; pb.setAttribute('aria-pressed', paused); pb.innerHTML = paused ? '&#9654;' : '&#10074;&#10074;';
      pb.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      var v = vidOf(cur); if (paused) { clearTimeout(timer); if (v) v.pause(); } else { if (v) v.play(); playCur(); }
    });
    var sx = null;
    car.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    car.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); sx = null; });
    new IntersectionObserver(function (es) { inView = es[0].isIntersecting; if (inView && !paused) playCur(); else { clearTimeout(timer); var v = vidOf(cur); if (v) v.pause(); } }, { threshold: .25 }).observe(car);
    playCur();
  }

  /* one-line headlines: shrink each headline just enough to fit its box (tablet and desktop) */
  var heads = [].slice.call(root.querySelectorAll('h1, h2'));
  function fitHeads() {
    heads.forEach(function (h) {
      h.style.fontSize = ''; h.classList.remove('wn-fit');
      if (window.innerWidth < 750) return;
      h.classList.add('wn-fit');
      var w = h.clientWidth, base = parseFloat(getComputedStyle(h).fontSize), size = base, n = 0;
      while (h.scrollWidth > w + 1 && size > base * .55 && n++ < 40) { size *= .97; h.style.setProperty('font-size', size + 'px', 'important'); }
      if (h.scrollWidth > w + 1) { h.classList.remove('wn-fit'); h.style.fontSize = ''; }
    });
  }
  fitHeads();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitHeads);
  window.addEventListener('load', fitHeads);
  var fitT; window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(fitHeads, 150); });

  /* scroll reveals */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.18 });
  root.querySelectorAll('.reveal,.wn-forest').forEach(function (el) { io.observe(el); });

  /* ribbon: duplicate content so the loop is seamless */
  root.querySelectorAll('.wn-ribbon .wn-track').forEach(function (t) {
    var unit = t.innerHTML;
    function fill() { /* repeat the phrases until one half is wider than the screen, then double it, so the loop never shows an end */
      t.innerHTML = unit;
      var n = 0; while (t.scrollWidth < window.innerWidth * 1.15 && n++ < 20) t.innerHTML += unit;
      var half = t.scrollWidth; t.innerHTML += t.innerHTML;
      t.style.animationDuration = Math.max(20, half / 55) + 's';   /* constant speed whatever the screen size */
    }
    fill(); var rw = window.innerWidth;
    window.addEventListener('resize', function () { if (Math.abs(window.innerWidth - rw) > 40) { rw = window.innerWidth; fill(); } });
  });

  if (reduce) return;

  /* ---------- background snowfall that drifts with scrolling ---------- */
  var bg = root.querySelector('.wn-snow');
  if (bg) {
    var bx = bg.getContext('2d'), flakes = [], lastY = window.scrollY, push = 0, onScreen = true, W = 0, H = 0;
    function size() {
      W = window.innerWidth; H = window.innerHeight;
      bg.width = W * DPR; bg.height = H * DPR; bx.setTransform(DPR, 0, 0, DPR, 0, 0);
      var n = mobile.matches ? 38 : 90; flakes = [];
      for (var i = 0; i < n; i++) flakes.push({ x: Math.random() * W, y: Math.random() * H, r: 1 + Math.random() * 3.2, v: .25 + Math.random() * .7, a: Math.random() * 6.28, s: .004 + Math.random() * .01 });
    }
    size(); window.addEventListener('resize', size);
    window.addEventListener('scroll', function () { var y = window.scrollY; push += (y - lastY) * .06; lastY = y; }, { passive: true });
    new IntersectionObserver(function (e) { onScreen = e[0].isIntersecting; }).observe(root);
    (function tick() {
      if (onScreen && !document.hidden) {
        bx.clearRect(0, 0, W, H); push *= .9;
        for (var i = 0; i < flakes.length; i++) {
          var f = flakes[i]; f.a += f.s;
          f.y += f.v + f.r * .12 - push * (f.r / 3); f.x += Math.sin(f.a) * .4;
          if (f.y > H + 6) { f.y = -6; f.x = Math.random() * W; } if (f.y < -8) { f.y = H + 4; }
          if (f.x > W + 6) f.x = -6; if (f.x < -6) f.x = W + 6;
          bx.beginPath(); bx.arc(f.x, f.y, f.r, 0, 6.283); bx.fillStyle = 'rgba(255,255,255,' + (.55 + f.r / 8) + ')';
          bx.shadowColor = 'rgba(111,199,234,.55)'; bx.shadowBlur = 4; bx.fill();
        }
      }
      requestAnimationFrame(tick);
    })();
  }

  /* ---------- per-flavor scene effects ---------- */
  function Scene(art) {
    var img = art.querySelector('img'), cv = document.createElement('canvas');
    art.appendChild(cv);
    var cx = cv.getContext('2d'), w = 0, h = 0, box = (art.dataset.box || '0,0,0,0').split(',').map(Number), parts = [], live = false, t0 = performance.now(), kind = art.dataset.fx, kick = 0;
    function fit() { w = art.clientWidth; h = art.clientHeight; cv.width = w * DPR; cv.height = h * DPR; cx.setTransform(DPR, 0, 0, DPR, 0, 0); }
    fit(); window.addEventListener('resize', fit); if (img && !img.complete) img.addEventListener('load', fit);
    function guard() { /* keep the drink box clean */
      var x0 = box[0] / 100 * w, y0 = box[1] / 100 * h; cx.clearRect(x0, y0, (box[2] - box[0]) / 100 * w, (box[3] - box[1]) / 100 * h);
    }
    function flake(x, y, r, a) { cx.beginPath(); cx.arc(x, y, r, 0, 6.283); cx.fillStyle = 'rgba(255,255,255,' + a + ')'; cx.fill(); }
    var n = kind === 'globe' ? 120 : 46;
    for (var i = 0; i < n; i++) parts.push({ x: Math.random(), y: Math.random(), r: .8 + Math.random() * 2.4, v: .0006 + Math.random() * .0016, ph: Math.random() * 6.28, o: Math.random() });
    var balls = [];
    function toss() {
      balls = [];
      for (var j = 0; j < 3; j++) balls.push({ t: -j * .28, sx: j % 2 ? 1.15 : -.15, ex: [.14, .86, .2][j], ey: [.86, .8, .62][j], r: [.085, .07, .06][j], puff: [] });
    }
    new IntersectionObserver(function (e) {
      var was = live; live = e[0].isIntersecting;
      if (live && !was) { kick = 1; if (kind === 'snowball') toss(); }
    }, { threshold: .35 }).observe(art);
    art.addEventListener('mouseenter', function () { kick = Math.max(kick, .7); if (kind === 'snowball') toss(); });
    function frame(now) {
      requestAnimationFrame(frame);
      if (!live || document.hidden || !w) return;
      var t = (now - t0) / 1000; cx.clearRect(0, 0, w, h); kick *= .985;
      if (kind === 'globe') { /* swirl inside the glass, faster right after it scrolls in (a little shake) */
        var gx = .5 * w, gy = .4 * h, gr = .44 * w;
        cx.save(); cx.beginPath(); cx.arc(gx, gy, gr, 0, 6.283); cx.clip();
        for (var i = 0; i < parts.length; i++) {
          var p = parts[i]; p.ph += .01 + kick * .06;
          var rad = (.25 + p.o * .75) * gr, ang = p.ph + p.o * 6.28;
          var x = gx + Math.cos(ang) * rad * (0.4 + kick * .6) + (p.x - .5) * gr * (1 - kick) ;
          p.y += p.v * (1 - kick * .8); if (p.y > 1) p.y = 0;
          var y = gy - gr + (p.y * 2 * gr) + Math.sin(ang) * rad * kick * .8;
          flake(x, y, p.r * .9, .5 + p.o * .45);
        }
        cx.restore();
      } else {
        for (var k = 0; k < parts.length; k++) { /* light snowfall */
          var q = parts[k]; q.y += q.v; if (q.y > 1.02) { q.y = -.02; q.x = Math.random(); }
          flake((q.x + Math.sin(t * .8 + q.ph) * .012) * w, q.y * h, q.r, .45 + q.o * .45);
        }
      }
      if (kind === 'ice') { /* light sweeping across the frozen lake */
        var sx = ((t * .12) % 1.6 - .3) * w, g = cx.createLinearGradient(sx - 90, 0, sx + 90, 0);
        g.addColorStop(0, 'rgba(255,255,255,0)'); g.addColorStop(.5, 'rgba(255,255,255,.42)'); g.addColorStop(1, 'rgba(255,255,255,0)');
        cx.save(); cx.globalCompositeOperation = 'lighter'; cx.fillStyle = g; cx.transform(1, 0, -.6, 1, .6 * h * .7, 0); cx.fillRect(sx - 90, h * .7, 180, h * .3); cx.restore();
      }
      if (kind === 'snowball') {
        balls.forEach(function (b) {
          b.t += .016; var u = Math.min(Math.max(b.t / .9, 0), 1); if (b.t < 0) return;
          var x = (b.sx + (b.ex - b.sx) * u) * w, y = (b.ey - Math.sin(u * Math.PI) * .32) * h, r = b.r * w * (1.25 - u * .25);
          if (u < 1) {
            var gg = cx.createRadialGradient(x - r * .35, y - r * .35, r * .1, x, y, r);
            gg.addColorStop(0, '#fff'); gg.addColorStop(.7, '#eef7fb'); gg.addColorStop(1, '#c9e3ee');
            cx.beginPath(); cx.arc(x, y, r, 0, 6.283); cx.fillStyle = gg; cx.fill();
          } else if (!b.done) { b.done = 1; for (var m = 0; m < 16; m++) b.puff.push({ x: x, y: y, vx: (Math.random() - .5) * 5, vy: -Math.random() * 4.5, l: 1 }); }
          b.puff.forEach(function (p) { p.x += p.vx; p.y += p.vy; p.vy += .22; p.l -= .025; if (p.l > 0) flake(p.x, p.y, 2.6 * p.l + 1, p.l); });
        });
      }
      guard();
    }
    requestAnimationFrame(frame);
  }
  root.querySelectorAll('.wn-art[data-fx]').forEach(Scene);
})();
